import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class AgroService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'agro';

  getLast(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/last';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  getDateGenerate(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/date';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  getGeotiff(): Observable<ArrayBuffer> {
    // check and set params of pagination
    // const uri = _appSettings.API_ENDPOINT_STATIC + `forecast/GFS/000/gfs-eu_europe_regular-lat-lon_pressure-level_2020091400_000_500_T.tiff`;
    const uri = _appSettings.API_ENDPOINT_STATIC + 'geotiff/agro.tiff';
    // const uri = `//localhost:83/files/forecast/GFS/000/gfs-eu_europe_regular-lat-lon_pressure-level_2020090700_000_500_temperature.tiff`;
    // const uri = `//localhost:83/files/forecast/icon_eu_europe_regular_lat_lon_single_level_2020090800_006_T_2M.tiff`;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<ArrayBuffer>(uri, {headers: headers, responseType: 'ArrayBuffer' as 'json'});
  }
  getStatics(): Observable<string[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/static';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<string[]>(uri, {headers: headers});
  }
}
